export const SPORTS_RO = {
  SPORTS_RO_CALCULATOR: 'transactions/rollover-calculator',
}
